import axios from "axios";

export const GetPackages = (obj, organisation_id="", searchText="") => {
  return axios
    .get(
      `${process.env.REACT_APP_NOT_SECRET_CODE}/organizations/leads/admin?organisation_id=${organisation_id}&search_text=${searchText}`,
      {
        headers: {
          "Content-Type": "application/json",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      }
    )
    .then((res) => res.data)
    .catch((err) => {
      console.error("Error fetching packages:", err.response || err);
      throw err;
    });
};

export const getClaimOrganizationList = (obj) => {
  return axios
    .get(process.env.REACT_APP_NOT_SECRET_CODE + `/claimableb2b`, {
      headers: {
        "Content-Type": "application/json ",
        "X-Request-ID": "124",
        "X-Country-Code": "BD",
        "X-Client-Name": "WEBSITE",
        "X-Client-Version": "123",
        Authorization: "Bearer " + obj,
      },
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const deleteLead = (lead_id, obj) => {
  return axios
    .delete(
      process.env.REACT_APP_NOT_SECRET_CODE + "/deleteorganization/" + lead_id,
      {
        headers: {
          "Content-Type": "application/json ",
          "X-Request-ID": "124",
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          Authorization: "Bearer " + obj,
        },
      }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      console.log(err);
    });
};
